import { Anchor } from '@/components'

import styles from './FilterCards.module.scss'

export const FilterCards = ({ filters, activeFilterIndex, onSelectFilter }) => {
  return (
    <div className={styles.filterCards}>
      {filters.map(({ icon, text }, index) => {
        const isActive = activeFilterIndex === index

        return (
          <Anchor
            icon={icon}
            text={text}
            isActive={isActive}
            id={`solutions-filter-${index}`}
            key={`solutions-filter-${index}`}
            onClick={() => onSelectFilter(index)}
          />
        )
      })}
    </div>
  )
}
